import { render } from "./ListeDevoirsPage.vue?vue&type=template&id=bb8f52c2&ts=true"
import script from "./ListeDevoirsPage.vue?vue&type=script&lang=ts"
export * from "./ListeDevoirsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__